import React from "react";
import Charts from "../components/Charts/Charts";
import { calculateInflation } from "../api";
import { GlobalContext } from "../context/GlobalContext";
import SEO from "../components/SEO/SEO";
import formatNumber from "../helpers/formatNumber";
import ToolDisclaimer from "../components/Disclaimer/ToolDisclaimer";

function ReturnOfInvestment() {
  const { isMobile } = React.useContext(GlobalContext);
  const [calculatedInflation, setCalculatedInflation] = React.useState({});
  const [inflationChartData, setInflationChartData] = React.useState([]);
  const selectedChartData = ["Kaufkraft", "Zukünftiger Preis"];

  //* handle form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    const amount = e.target[0]?.value;
    const inflation = e.target[1]?.value;
    const duration = e.target[2]?.value;

    try {
      const result = await calculateInflation(amount, inflation, duration);
      setCalculatedInflation(result);

      const chartData = [];
      result.details.forEach((el) => {
        chartData.push({
          name: `Jahr ${el.year}`,
          Kaufkraft: el?.futurePurchasingPower,
          "Zukünftiger Preis": el?.futurePrice,
        });
      });
      setInflationChartData(chartData);
    } catch (error) {}
  };

  return (
    <>
      <SEO
        title="Inflationsrechner"
        keywords="Inflationsrechner"
        description="Inflationsrechner"
        type="Inflationsrechner"
        url={window.location.href}
      />
      <div
        className={`${!isMobile && "article-text"} ${
          isMobile && "add-padding-20"
        } text-justify text-light`}
      >
        <h1 className="text-light article-header">Inflationsrechner</h1>
        <ToolDisclaimer />

        <br />
        <form onSubmit={handleSubmit} id="compoundInterestForm">
          <div className="form-group">
            <label className="text-light" for="formName">
              Ursprungsbertrag
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={1000}
                min={1}
              />
              <span className="input-group-text" id="basic-addon2">
                €
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Inflationsrate
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={2.3}
              />
              <span className="input-group-text" id="basic-addon2">
                %
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Zeitraum
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                defaultValue={10}
                min={1}
              />
            </div>
          </div>

          <div className="text-right">
            <button type="submit" className="btn btn-primary formsubmit">
              Berechnen
            </button>
          </div>
        </form>
        {calculatedInflation &&
          Object.keys(calculatedInflation)?.length > 0 && (
            <>
              <br />
              <p>
                Wenn du einen Betrag von
                <b className="visualizeLink linkIsInformative">
                  {` ${formatNumber(
                    calculatedInflation?.amount?.toFixed(2)
                  )}€ `}
                </b>
                auf einem unverzinsten Konto bei einer Inflationsrate von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.inflation?.toFixed(2)
                )}% `}</b>
                parkst, beträgt die Kaufkraft nach
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.duration?.toFixed(2)
                )} Jahren `}</b>
                nur noch
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.futurePurchasingPower?.toFixed(2)
                )}€`}</b>
                . Dies entspricht einem Kaufkraftverlust von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.lossOfPurchasingPower?.toFixed(2)
                )}%`}</b>
                .
                <br />
                Um dieselbe Kaufkraft wie heute zu haben, benötigst du zukünftig
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.futurePrice?.toFixed(2)
                )}€ `}</b>
                was einer Preissteigerung von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedInflation?.priceIncrease?.toFixed(2)
                )}% `}</b>
                entspricht.
              </p>

              <br />

              <Charts.Composed
                data={inflationChartData}
                titleX="name"
                bar={{ key: "Zukünftiger Preis", color: "#00ffcc" }}
                area={{ key: "Kaufkraft", color: "#ffff00" }}
                showTooltip
                tooltipValues={selectedChartData}
              />
            </>
          )}
      </div>
    </>
  );
}

export default ReturnOfInvestment;
